<!-- ============================================================================
     INTEGRAÇÃO GPL — Itens Pendentes (Sistema Legado + fluxo nativo Sankhya)
     Ver comentário de topo em itens-pendentes-legado.component.ts
     ============================================================================ -->
<div class="ip-shell">
  <div class="container">

  <!-- HEADER -->
  <div class="ip-header">
    <div class="ip-title-block">
      <div class="icon-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
      </div>
      <div class="title-text">
        <h1>Itens Pendentes</h1>
        <p>Itens sinalizados como "no outro Galpão" durante a separação</p>
      </div>
    </div>
    <div class="ip-header-right">
      <!-- Fonte única por vez (Legado OU Sankhya) -- ver comentário de topo
           no .ts sobre por que as duas nunca são buscadas juntas. -->
      <div class="ip-fonte-toggle">
        <button type="button" class="ip-fonte-btn" [class.ativa]="mostrarLegado" (click)="alternarFonte(true)">Sistema Legado</button>
        <button type="button" class="ip-fonte-btn" [class.ativa]="!mostrarLegado" (click)="alternarFonte(false)">Sankhya</button>
      </div>
      <button class="btn-refresh" (click)="buscarPendencias(true)" title="Atualizar">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path></svg>
      </button>
    </div>
  </div>

  <div *ngIf="erroResolver" class="alert alert-danger">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
    {{ erroResolver }}
  </div>

  <!-- LOADING -->
  <div *ngIf="carregando" class="loading-state">
    <app-loading-indicator></app-loading-indicator>
    <span>Carregando itens pendentes...</span>
  </div>

  <!-- ERRO -->
  <div *ngIf="erro && !carregando" class="error-state">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
    <p>{{ erro }}</p>
  </div>

  <!-- VAZIO -->
  <div *ngIf="!carregando && !erro && itens.length === 0" class="empty-state">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
    <p>Nenhum item pendente no momento</p>
  </div>

  <!-- GRID DE CARDS -->
  <div *ngIf="!carregando && !erro && itens.length > 0" class="itens-grid">
    <div class="item-card" *ngFor="let item of itens">

      <div class="card-header">
        <span class="venda-badge">Venda {{ item.numeroVenda }}</span>
        <span class="origem-badge" [class.origem-sankhya]="item.origem === 'sankhya'">
          {{ item.origem === 'sankhya' ? 'Sankhya' : 'Sistema Legado' }}
        </span>
        <span class="origem-badge origem-etapa" *ngIf="item.etapa">
          {{ item.etapa === 'conferencia' ? 'Conferência' : 'Separação' }}
        </span>
        <span class="qty-badge">Qtde: {{ item.quantidade }}{{ item.unidade ? ' ' + item.unidade : '' }}</span>
      </div>

      <div class="card-body">
        <div class="pn-linha" *ngIf="item.pn">
          <span class="pn-label">P/N</span> {{ item.pn }}
        </div>
        <div class="descricao-linha">{{ item.descricao }}</div>

        <div class="campo-row" *ngIf="item.cd || item.local || item.estoque !== undefined || item.nomeCliente">
          <span class="campo-valor" *ngIf="item.cd"><span class="mini-label">CD</span> {{ item.cd }}</span>
          <span class="campo-valor" *ngIf="item.nomeCliente"><span class="mini-label">Cliente</span> {{ item.nomeCliente }}</span>
          <span class="badge loc" *ngIf="item.local">
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
            {{ item.local }}
          </span>
          <span class="badge estoque" [class.negativo]="item.estoque <= 0" *ngIf="item.estoque !== undefined && item.estoque !== null" title="Saldo disponível">Disponível: {{ item.estoque }}</span>
        </div>

        <div class="sinalizacao-box">
          <span class="sinalizacao-quem">Sinalizado por {{ item.sinalizadoPor || 'separador' }}</span>
          <span class="sinalizacao-data" *ngIf="item.dataSinalizacao">{{ item.dataSinalizacao | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="item-observacao" *ngIf="item.observacao">{{ item.observacao }}</div>
      </div>

      <div class="card-footer">
        <button class="btn-resolver" (click)="abrirConfirmacao(item)">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          Já busquei este item
        </button>
      </div>

    </div>
  </div>

  </div>
</div>

<!-- ── CONFIRMAÇÃO "JÁ BUSQUEI ESTE ITEM?" (sem identificação) ──────────── -->
<div class="modal-overlay" *ngIf="confirmando" (click)="fecharConfirmacao()">
  <div class="modal-box modal-confirmar" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px;margin-right:6px"><polyline points="20 6 9 17 4 12"></polyline></svg>
        Já buscou este item?
      </h2>
      <button class="btn-fechar-modal" (click)="fecharConfirmacao()" [disabled]="resolvendoChave !== null">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc">
        {{ confirmando?.pn ? confirmando?.pn + ' — ' : '' }}{{ confirmando?.descricao }} (Venda {{ confirmando?.numeroVenda }}).
        Ao confirmar, o item sai da fila de pendências e o separador é avisado que já pode conferir/finalizar.
      </p>
      <div *ngIf="erroResolver" class="alert alert-danger" style="margin-top:12px">{{ erroResolver }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharConfirmacao()" [disabled]="resolvendoChave !== null">Não</button>
      <button class="btn-concluir" (click)="confirmarResolucao()" [disabled]="resolvendoChave !== null">
        {{ resolvendoChave !== null ? 'Confirmando...' : 'Sim, já busquei' }}
      </button>
    </div>
  </div>
</div>
